'use strict';



const $ = require('jquery');
const debounce = require('debounce');
const findContent = $element => $element.find('.js-accordion-content');
const findContentInner = $element => $element.find('.js-accordion-content-inner');



const methods = {

	close: $item => {
		const $content = findContent($item);
		$item.removeClass('c-qa--is-open');
		$content.css({ maxHeight: 0 });
	},

	open: $item => {
		const $content = findContent($item);
		const $inner = findContentInner($content);
		$item.addClass('c-qa--is-open');
		$content.css({ maxHeight: $inner.innerHeight() });
	}

};



module.exports = class Accordion {



	constructor($container, options) {

		this.elements = {
			$items: $container.find('.js-accordion-item'),
			$container
		};

		this.state = { open: null };
		this.init();

	}



	init() {

		const _this = this;
		const setOpenHeight = debounce(this.setOpenHeight.bind(this), 500);

		this.elements.$container.on('click', '.js-accordion-trigger', function() {
			const $target = $(this).parent('.js-accordion-item');
			const target = $target.attr('id');
			_this.setOpen(target);
		});

		$(window).on('resize', setOpenHeight);

	}



	setOpen(target) {

		if(target === this.state.open) {
			return this.setClose(target);
		}

		this.state.open = target;
		this.render();

	}



	setClose(target) {
		this.state.open = null;
		this.render();
	}



	setOpenHeight() {

		const $item = this.elements.$items.filter(`[id$=${this.state.open}]`);

		if(!$item) {
			return;
		}

		methods.open($item);

	}



	render() {

		const _this = this;

		this.elements.$items.each(function() {

			const $item = $(this);

			const method = $item.is(`[id$=${_this.state.open}]`) ?
				'open' :
				'close';

			methods[method]($item);

		});

	}



};